export default __webpack_public_path__ + "37a6d2f35ebf866fadaf5d45310b928e.glb";